import type { SkeletonContainerElement } from "shared/atoms/SkeletonLayout";
import { SkeletonLayout } from "shared/atoms/SkeletonLayout";

export const TreatmentEditorSkeleton: React.FC = () => {
  return (
    <SkeletonLayout
      layout={{
        type: "column",
        spacing: 4,
        children: [
          {
            type: "row",
            alignItems: "center",
            justifyContent: "space-between",
            children: [
              { type: "skeleton", variant: "rounded", width: 216, height: 40 },
              { type: "skeleton", variant: "text", typographyVariant: "subtitle1", width: 80 },
            ],
          },
          {
            type: "column",
            spacing: 2,
            children: [...Array(6)].map(
              (): SkeletonContainerElement => ({
                type: "column",
                spacing: 2,
                padding: 1.5,
                children: [
                  {
                    type: "row",
                    spacing: 1.5,
                    children: [
                      { type: "skeleton", variant: "rounded", width: "52px", height: "52px" },
                      {
                        type: "column",
                        spacing: 0.5,
                        children: [
                          { type: "skeleton", variant: "text", typographyVariant: "body_bold", width: 160 },
                          { type: "skeleton", variant: "text", typographyVariant: "label", width: 60 },
                        ],
                      },
                      {
                        type: "row",
                        spacing: 1,
                        width: "auto",
                        sx: { marginLeft: "auto" },
                        children: [
                          { type: "skeleton", variant: "rounded", width: 32, height: 32 },
                          { type: "skeleton", variant: "rounded", width: 32, height: 32 },
                          { type: "skeleton", variant: "rounded", width: 32, height: 32 },
                        ],
                      },
                    ],
                  },
                  {
                    type: "row",
                    spacing: 2,
                    sx: { justifyContent: "space-between" },
                    children: [
                      {
                        type: "skeleton",
                        variant: "rounded",
                        width: 180,
                      },
                      {
                        type: "skeleton",
                        variant: "rounded",
                        width: 270,
                      },
                    ],
                  },
                ],
              })
            ),
          },
        ],
      }}
    />
  );
};
